import { POPOVER_CONTENTS } from './MoreQuickFiltersButton';
import { AddIcon } from 'foundations-assets';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AddQuickFilterButton = ({
  disabled,
  setCurrentPopoverContent
}) => {
  return /*#__PURE__*/_jsx(Tooltip, {
    title: disabled ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.quickFiltersBar.addQuickFilterDisabled"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.quickFiltersBar.addQuickFilter"
    }),
    children: /*#__PURE__*/_jsxs(Button, {
      "data-selenium-test": "MorePopover-addFilter",
      disabled: disabled,
      size: "sm",
      use: "transparent",
      onClick: () => setCurrentPopoverContent(POPOVER_CONTENTS.ADD_QUICK_FILTERS),
      children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.quickFiltersBar.add"
      })]
    })
  });
};
export default AddQuickFilterButton;